const PURCHASE_OPTIONS_SELECTOR = '.mhecomm-purchase-options';
const REVEAL_TRIGGER_SELECTOR = `${PURCHASE_OPTIONS_SELECTOR} .enable-all-pricing-options`;

function revealAllPurchaseOptions(trigger) {
  const purchaseOptions = trigger.closest(PURCHASE_OPTIONS_SELECTOR);

  if (!purchaseOptions) {
    return;
  }

  purchaseOptions.querySelectorAll('.google-campaign').forEach((element) => {
    element.classList.remove('google-campaign', 'd-none');
  });
  purchaseOptions.querySelectorAll('.google-campaign-show').forEach((element) => {
    element.classList.add('d-none');
    element.classList.remove('google-campaign-show');
  });
  purchaseOptions.querySelectorAll('.google-campaign-hide').forEach((element) => {
    element.classList.remove('d-none', 'google-campaign-hide');
  });
}

export function initializeRevealAllPurchaseOptions(root = document) {
  root.querySelectorAll(REVEAL_TRIGGER_SELECTOR).forEach((trigger) => {
    if (trigger.dataset.revealAllPurchaseOptionsInitialized === 'true') {
      return;
    }

    trigger.dataset.revealAllPurchaseOptionsInitialized = 'true';
    trigger.addEventListener('click', () => revealAllPurchaseOptions(trigger));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeRevealAllPurchaseOptions(), { once: true });
} else {
  initializeRevealAllPurchaseOptions();
}
